










import Vue from 'vue'
import { Spell } from '@/types'
import SpellSearchResult from '@/components/SpellSearchResult.vue'
import spellFilter from '@/util/spell-filter'

export default Vue.extend({
  name: 'SpellSearch',
  data () {
    return {
      searchInput: '',
    }
  },
  computed: {
    spells (): Array<Spell> {
      return Object.values(this.$store.state.spells)
    },
    searchResults (): Array<Spell> {
      return spellFilter.searchFilter(this.spells, this.searchInput)
    },
  },
  components: {
    SpellSearchResult,
  },
})
